// extracted by mini-css-extract-plugin
module.exports = {"grid":"i_Zk","heading":"i_Zl","social-container":"i_Zm","social":"i_Zn","clipboard":"i_Zo","copy":"i_Zp","copied":"i_Zq","link":"i_Zr"};